export default __webpack_public_path__ + "static/media/share-icon.07bc0a38.svg";